var render, staticRenderFns
import script from "./AccordionContent.vue?vue&type=script&lang=ts&"
export * from "./AccordionContent.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionContent.vue?vue&type=style&index=0&id=681877c8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports